export enum SatelliteType {
    GPS, ADDGLONASS, ADDGALILEO, ALL
}